// Local translations for page-level UI only
export const T = {
  en_GB: {
    advisorWarning:
      "Advisors cannot access public client links. Please sign out first or use the advisor dashboard.",
    failedToLoad: "Failed to load form",
  },
  nb_NO: {
    advisorWarning:
      "Rådgivere kan ikke få tilgang til offentlige kundelenker. Vennligst logg ut først eller bruk rådgiverdashbordet.",
    failedToLoad: "Kunne ikke laste skjemaet",
  },
} as const;
